import React from 'react';
import ReactWordcloud from 'react-d3-cloud';
import { Header, Segment } from 'semantic-ui-react';

import { CHART_HEIGHT, CHART_HEIGHT_MOBILE } from './utils';
import { CustomContainer } from '../common';

export default ({
  data,
  fontSizeMapper,
  getWords,
  isFetching,
  isMobile,
  title,
  width,
}) => {
  const h = isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT;

  return (
    <CustomContainer>
      <Header as={isMobile ? 'h3' : 'h2'} attached="top">
        {title}
      </Header>
      <Segment
        attached
        loading={isFetching}
        style={{ height: h }}
      >
        <ReactWordcloud
          height={h}
          width={width}
          data={getWords(data)}
          fontSizeMapper={fontSizeMapper}
          padding={0}
          rotate={0}
        />
      </Segment>
    </CustomContainer>
  );
};
